import React, { useState } from 'react';

import Axios from 'axios';

import { forceReloadInvoicePrints } from '@hooks/API/UseInvoices';

import NwDrawer from '@components/Gui/NwDrawer';
import PdfPrintDrawer from '@components/PdfPrintDrawer/PdfPrintDrawer';
import IconTemplateSelector from '@components/TemplateSelector/IconTemplateSelector';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const PrintEditableInvoiceButton = ({ invoiceID, invoiceType, placement }) => {
    const [docVersion, setDocVersion] = useState(null);

    let areaName = 'Invoice';
    switch (invoiceType) {
        case 'Model':
            areaName = 'ModelInvoice';
            break;
        case 'Agency':
            areaName = 'AgencyInvoice';
            break;
        default:
            break;
    }

    const onClosePrintDrawer = () => {
        setDocVersion(null);
        forceReloadInvoicePrints(invoiceID);
    };

    const handleGenerateExport = async (templateid) => {
        const data = {
            Template: templateid,
            Area: areaName,
            OutputFileName: areaName,
            ID: invoiceID,
        };
        const exportResponse = await Axios.post(`/invoices/printeditable`, data);
        setDocVersion(exportResponse);
    };

    return (
        <>
            <IconTemplateSelector
                icon={byPrefixAndName.fasl['file-pdf']}
                templateArea={areaName}
                placement={placement}
                onClick={handleGenerateExport}
                size="2x"
            />
            {docVersion && (
                <NwDrawer
                    onClose={onClosePrintDrawer}
                    padding="0px"
                    title="Print"
                    visible={true}
                    whiteBg={false}
                    width="80vw"
                    maxWidth={'1024px'}
                >
                    <PdfPrintDrawer docVersion={docVersion} saveButton onClose={onClosePrintDrawer} />
                </NwDrawer>
            )}
        </>
    );
};

export default PrintEditableInvoiceButton;
